// Imperative mirror of the currently-active feature flags, for the rare non-React paths that can't use the `useFeatureFlags` hook (e.g. clipboard helpers invoked from menu actions and keyboard handlers). Kept in sync by `FeatureFlagsProvider` (see flags.tsx). React components should still use `useFeatureFlags` so they re-render on change.
let activeFlagNames = new Set<string>();

export function setActiveFeatureFlagNames(names: Iterable<string>): void {
  activeFlagNames = new Set(names);
}

export function isFeatureFlagEnabled(name: string): boolean {
  return activeFlagNames.has(name);
}
